export default "__VITE_ASSET__BIaB08u$__"